import debounce from 'lodash/debounce'
import { useCallback, useInsertionEffect, useRef } from 'react'

export const useDebouncedCallback = <T extends (...args: any) => any>(callback: T, delay: number) => {
  // Callback reference stabilization
  const handler = useRef(callback)
  useInsertionEffect(() => {
    handler.current = callback
  }, [callback])

  return useCallback(debounce(((...args) => handler.current(...args)) as T, delay), [delay])
}
